import { render, staticRenderFns } from "./BaseModalError.vue?vue&type=template&id=ce35174c&"
import script from "./BaseModalError.vue?vue&type=script&lang=js&"
export * from "./BaseModalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports